var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10.8,
    viewBox: "0 0 18 10.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "align-center-alt",
    d: "M4.7,7.8H17.3a.9.9,0,1,0,0-1.8H4.7a.9.9,0,1,0,0,1.8Zm14.4,2.7H2.9a.9.9,0,1,0,0,1.8H19.1a.9.9,0,1,0,0-1.8ZM17.3,15H4.7a.9.9,0,0,0,0,1.8H17.3a.9.9,0,1,0,0-1.8Z",
    transform: "translate(-2 -6)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBar);
export default __webpack_public_path__ + "static/media/left-bar.fb8999268bf7b7022c077449af67d480.svg";
export { ForwardRef as ReactComponent };